import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next";
import styles from "../../assets/module/common/common.module.css"
import { IsNotNull } from "../../controllers/commons/helper"
import { menulist } from './Data-Menu'

const RolesController = require('../../controllers/admins/roles')

const SidebarContent = props => {
  const ref = useRef();
  const [roles,setRoles] = useState([])

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(async ()=>{
    let r = await RolesController.getRoles()
    setRoles(r)
  },[])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }
    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement
      if (parent2) {
        parent2.classList.add("mm-show") // ul tag
        const parent3 = parent2.parentElement // li tag
        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  const menu = menulist()

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {
              menu.map((x, i) => {
                return <li className={`${IsNotNull(x.main.roles) ?
                  x.main.roles.filter(element => roles.includes(element)).length > 0 ? "" : styles['hide-el'] : ''} `} key={i} id={IsNotNull(x.id_main) ?
                    x.id_main : ''}>
                  <Link to={x.main.link} className={`${IsNotNull(x.submenu) ? 'has-arrow' : ''} waves-effect`}>
                    <i className={x.main.icon}></i>
                    <span>{props.t(x.main.title)}</span>
                  </Link>
                  {
                    IsNotNull(x.submenu) ?
                      <ul className={`sub-menu`} aria-expanded="false" id={IsNotNull(x.id_submenu) ? x.id_submenu : ''}>
                        {
                          x.submenu.map((s, idx) => {
                            return <li key={idx} className={`${IsNotNull(s.roles) ? s.roles.filter(element => roles.includes(element)).length > 0 ? "" : styles['hide-el'] : ''}`}>
                              <Link to={s.link}>{props.t(s.title)} </Link>
                            </li>
                          })
                        }
                      </ul>
                      : null
                  }
                </li>
              })
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
